import { Falcon } from '@/components/home/Falcon';
import { Station } from '@/components/home/Station';
import { XWing } from '@/components/home/XWing';

export function Atmosphere() {
  return (
    <div className="atmosphere" aria-hidden="true">
      <div className="atmosphere__stars" />
      <Station className="atmosphere__station" />
      <Falcon className="atmosphere__falcon" />
      <svg className="atmosphere__destroyer" viewBox="0 0 640 220" fill="none">
        <defs>
          <linearGradient id="destroyer-hull" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#3a4452" />
            <stop offset="55%" stopColor="#161c24" />
            <stop offset="100%" stopColor="#080a0d" />
          </linearGradient>
        </defs>
        <polygon points="12,110 628,18 628,202" fill="url(#destroyer-hull)" />
        <polygon points="12,110 628,18 628,202" stroke="rgba(138,166,188,0.28)" strokeWidth="1" />
        <line x1="80" y1="110" x2="628" y2="110" stroke="rgba(8,10,13,0.7)" strokeWidth="6" />
        <line x1="80" y1="110" x2="628" y2="110" stroke="rgba(138,166,188,0.2)" strokeWidth="1" />
        <polygon points="470,110 508,46 546,110" fill="#1a222c" />
        <rect x="498" y="58" width="20" height="28" fill="#12161c" />
        <circle cx="616" cy="92" r="4" fill="#8aa6bc" opacity="0.7" />
        <circle cx="616" cy="128" r="4" fill="#8aa6bc" opacity="0.7" />
      </svg>
      <XWing className="atmosphere__xwing" />
      <div className="atmosphere__visor" />
      <div className="atmosphere__grain" />
    </div>
  );
}
